import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Condominio } from 'src/app/models/proy_cond.model';
import { FormService } from 'src/app/services/form.service';

@Component({
  selector: 'app-proyectos-tipo',
  templateUrl: './proyectos-tipo.component.html',
  styleUrls: ['./proyectos-tipo.component.css']
})
export class ProyectosTipoComponent {

  public rows = [];
  public actualRow;
  public condominio: Condominio;
  public form;
  public totalUni;



  constructor() {
    this.form = new FormGroup({
      sup_total: new FormControl(""),
      cant_sitios: new FormControl("")
    })
    if (!JSON.parse(localStorage.getItem("condominio"))) {
      localStorage.setItem("condominio", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("condominio"));

      this.form.controls['sup_total'].setValue(this.rows[0] ? this.rows[0].sup_total : 0)
      this.form.controls['cant_sitios'].setValue(this.rows[0] ? this.rows[0].cant_sitios : "")
    }
    this.condominio = { sup_total: "", cant_sitios: "" };

  }

  add_condominio() {

    localStorage.setItem("condominio", JSON.stringify([]));
    this.actualRow = localStorage.getItem("condominio");
    this.rows = JSON.parse(this.actualRow);
    this.rows = this.rows.concat({
      sup_total: this.form.value.sup_total,
      cant_sitios: this.form.value.cant_sitios,
    })
    localStorage.setItem("condominio", JSON.stringify(this.rows));
  }

  delete_condominio(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("condominio", JSON.stringify(this.rows));
      }
    }
  }


}
